import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';

import './home.css';
import routes from '../../utils/routes';
import Spinner from '../spinner/spinner';

class Home extends React.Component {
    render() {
        return (
            <div className='home-wrapper'>
                <div className='home-title'>
                    <h1>MEUS CURSOS</h1>
                </div>
                <div className='classes-container'>
                    { ( !this.props.loading ) ?
                        this.props.classes.length > 0
                            ? this.props.classes.map(c => <Class {...c} key={c.classId} student={this.props.student}/>) :
                            <section className='empty-attachment-wrapper'>
                                <i className='fa fa-graduation-cap' />
                                <h3>Você não possui turmas ativas</h3>
                            </section>
                        : <Spinner/>}
                </div>
            </div>
        );
    }
}

class Class extends React.Component {

    render() {
        const {
            picture,
            courseName,
            className,
            classId,
            expired,
            endDate,
            startDate,
        } = this.props;
        const canAccess = !expired;

        return (
            <div className='class-wrapper'>
                <div className='class-display'>
                    <img src={picture} alt='Display'/>
                </div>
                <div className='class-display-foreground'>
                    <span className='course-name'>{courseName}</span>
                    <span className='class-name'>{className}</span>
                    {canAccess &&
                    <Link to={routes.RESOURCES(classId)}>
                        <button className='class-display-access'>Acessar</button>
                    </Link>}
                </div>
                {(endDate || startDate) && this.renderEndInfo()}
            </div>
        );
    }

    renderDateOfExpiration = (days) => {
        let date = new Date();
        date.setDate( date.getDate() + days );
        return date.toLocaleDateString('pt-BR');
    }

    renderEndInfo = () => {
        const { startDate, endDate, student, classId } = this.props;
        const extension = student[classId] ? student[classId].extension : 0;
        const finalDate = extension ? moment(endDate).add(extension, 'd') : moment(endDate);
        const toEndDays = finalDate.endOf('d').diff(moment().startOf('d'), 'd');
        const toStartDays = moment(startDate).startOf('d').diff(moment().startOf('d'), 'd');

        const isNotStarted = moment(startDate).startOf('d') > moment().startOf('d');
        return (
            <div className='end-date-info'>
                {toEndDays < 0 && <p>Período encerrado</p>}
                {!isNotStarted && toEndDays >= 0 && endDate && <p>{ `Expira em ${this.renderDateOfExpiration(toEndDays)}`}</p>}
                {!isNotStarted && toEndDays >= 0 && endDate && <p>{`${toEndDays} dia(s)`}</p> }
                {isNotStarted && <p>{`Iniciará em ${toStartDays} dia(s)`}</p>}
            </div>
        );
    };
}

const mapStateToProps = ({ App }) => ({
    classes: App.classes.sort(sortClass),
    student: App.student,
    loading: App.loadingCourses,
});

const sortClass = (a, b) => {
    if (!a.startDate) {
        return 1;
    } else if (!b.startDate) {
        return -1;
    }

    return moment(a.startDate) < moment(b.startDate) ? -1 : 1;
};

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/home/home.js